export enum AppConstants {
  UPDATE_COMPONENT_SIZE = "UPDATE_COMPONENT_SIZE",
  SET_TRAINING_DATA_SET = "SET_TRAINING_DATA_SET",
}
